import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../multiple-realms/login/styles/styled";
import LogoLogan from "./../assets/logo_logan.svg";

const NotFoundPage = () => {
  const router = useNavigate();
  const PAGE_NOT_FOUND = useTranslation({ id: "page_not_found" });
  const PAGE_NOT_FOUND_DESCRIPTION = useTranslation({ id: "page_not_found_description" });
  const BACK_TO_HOME = useTranslation({ id: "back_to_home" });
  const PRIVACY_INFORMATION = useTranslation({ id: "privacy_information" });

  const handleRedirectHome = () => {
    router("/", { replace: true });
  };

  return (
    <S.Container>
      <S.Content>
        <S.LogoContainer>
          <S.Logo src={LogoLogan} />
        </S.LogoContainer>
        <S.SSOContainer>
          <S.SSOContainerTitle>
            <div>
              <span className="login-title">{PAGE_NOT_FOUND}</span>
            </div>
            <span className="login-subtitle">{PAGE_NOT_FOUND_DESCRIPTION}</span>
          </S.SSOContainerTitle>
          <S.ContainerButtons>
            <S.SSOContainerButtonsContainer>
              <Button className="primaryButton" type="primary" onClick={handleRedirectHome} size="large" data-testid="back_to_home_button">
                {BACK_TO_HOME}
              </Button>
            </S.SSOContainerButtonsContainer>
          </S.ContainerButtons>
        </S.SSOContainer>
      </S.Content>
      <S.FooterBar>
        <S.Label>{PRIVACY_INFORMATION}</S.Label>
      </S.FooterBar>
    </S.Container>
  );
};

export default NotFoundPage;
